export default __webpack_public_path__ + "static/location-header-bg-b047faec631bff212ad83aefe89d29c8.jpg";